import dayjs from "dayjs";

export const isLocationActive = (loc: any) => !loc?.frozen;

export const isLocationVisibleForPeriod = (loc: any, activeMonths: string[]) => {
  if (!loc?.frozen) return true;
  if (!loc.frozenAt) return false;
  const frozenMonth = dayjs(loc.frozenAt).format("YYYY-MM");
  return activeMonths.length > 0 && activeMonths.every((m) => m < frozenMonth);
};
